import React from 'react';
import { Col, Row, useScreenClass } from 'react-grid-system';
import { PrimaryLargeButtonFlex } from '@Components/controls/Button/Button';
import Icon from '@Components/Icon/Icon';
import { getLang } from '@Utils/language/language';
import { ButtonWrapper, EmptyStateDescription, EmptyStateTitle } from './Cart.styled';
import { useHistory } from 'react-router-dom';
import useTranslate from '@Utils/hooks/useTranslate';

const EmptyCartView = (): JSX.Element => {
	const history = useHistory();
	const { translate } = useTranslate();
	const screenClass = useScreenClass();
	const getIconSize = () => (screenClass.includes('xs') ? 185 : 286);

	return (
		<Row>
			<Col>
				<Icon name="cartEmptyState" width={getIconSize()} height={getIconSize()} />
				<EmptyStateTitle>{translate('navbar.cart.empty-state.title')}</EmptyStateTitle>
				<EmptyStateDescription>{translate('navbar.cart.empty-state.description')}</EmptyStateDescription>
				<Row justify="center">
					<ButtonWrapper>
						<PrimaryLargeButtonFlex
							uniqueId="navbar.cart.go-to-store"
							onClick={() => history.push(`/${getLang()}/store`)}
						>
							{translate('navbar.cart.go-to-store')}
						</PrimaryLargeButtonFlex>
					</ButtonWrapper>
				</Row>
			</Col>
		</Row>
	);
};

export default EmptyCartView;
